import { render, staticRenderFns } from "./SendMessageDialog.vue?vue&type=template&id=07e47972&scoped=true"
import script from "./SendMessageDialog.vue?vue&type=script&lang=js"
export * from "./SendMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./SendMessageDialog.vue?vue&type=style&index=0&id=07e47972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e47972",
  null
  
)

export default component.exports